export const undoManagementMixin = {
  methods: {
    undoChanges() {
      Object.entries(this.initialValues).forEach(([key, value]) => {
        this[key] = value
      })
      this.$v.$reset()
    },
  }
}
